// extracted by mini-css-extract-plugin
export var forecastsWrapper = "WeatherWidget-module--forecastsWrapper--37xKM";
export var forecasts = "WeatherWidget-module--forecasts--3o4Iu";